import { render, staticRenderFns } from "./DetailedAudioWithText.vue?vue&type=template&id=89456762&scoped=true&"
import script from "./DetailedAudioWithText.vue?vue&type=script&lang=js&"
export * from "./DetailedAudioWithText.vue?vue&type=script&lang=js&"
import style0 from "./DetailedAudioWithText.vue?vue&type=style&index=0&id=89456762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89456762",
  null
  
)

export default component.exports